import { ProductDataOutput } from "../../../shared/helpers/productHelper";
import ProductImage from "../ProductImage";
import { getImageUrl } from "../../../shared/helpers/getImageUrl";
interface ListItemImageProps {
  product: ProductDataOutput;
}





const ListItemImage = ({ product }: ListItemImageProps) => {
  const imageUrl = getImageUrl(product);

  return (
    <div className="listItemImage">
      <ProductImage
        height={40}
        width={40}
        localSrc={imageUrl}
        alt={product.name}
      />
    </div>
  );
};

export default ListItemImage;
